import { render, staticRenderFns } from "./SCSAwardEndorse.vue?vue&type=template&id=5d07342e&v-if=isLoggedIn&"
import script from "./SCSAwardEndorse.vue?vue&type=script&lang=js&"
export * from "./SCSAwardEndorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports